import { useState, useEffect } from 'react';
import { navContent } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hero');
            }}
            className="flex items-center shrink-0"
          >
            <img
              src={scrolled ? navContent.logoDark : navContent.logoWhite}
              alt={navContent.logoAlt}
              className="h-8 md:h-10 w-auto object-contain"
            />
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navContent.links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className={`text-sm font-medium tracking-wide transition-colors hover:text-primary-500 ${
                  scrolled ? 'text-foreground-800' : 'text-background-50'
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href={`tel:${navContent.ctaPhone}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm" />
              </span>
              {navContent.ctaText}
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-foreground-800' : 'text-background-50'
            }`}
            aria-label="메뉴 열기"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-lg`} />
            </span>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-4 space-y-1">
            {navContent.links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="block px-4 py-3 text-foreground-800 text-sm font-medium rounded-lg hover:bg-background-100 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href={`tel:${navContent.ctaPhone}`}
              className="block mx-4 mt-3 px-5 py-3 rounded-full text-center text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              {navContent.ctaText} {navContent.ctaPhone}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}